// extracted by mini-css-extract-plugin
module.exports = {"searchBar":"SearchBar_searchBar__3tC6U","inputText":"SearchBar_inputText__2CJFz","button":"SearchBar_button__3IQo1"};